import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import setYear from 'date-fns/set_year'
import addMonths from 'date-fns/add_months';
import lastDayOfMonth from 'date-fns/last_day_of_month';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import differenceInCalendarMonths from 'date-fns/difference_in_calendar_months'
import differenceInCalendarYears from 'date-fns/difference_in_calendar_years'
import {globalfunc} from '../globalfunc.js'
import CryptoJS from 'crypto-js'
import { getUsersByCompany } from './cacheService'
export default {
    namespaced: true,
    state: {
      datamembers:[],
      members:[],
      teamall:[],
      inputSearch: '',
      inputSearchArchive: '',
      type:'all',
      page:1,
      pagearchive: 1,
      size_page:10,
      sortfield:'value',
      sortfieldarchive:'value',
      sortorder:'asc',
      sortorderarchive:'asc',
      dataexport:[],
      results: [],
      resultsArchive: [],
      modalMemberData: [],
      membersByKey: [],
      membersArchiveByKey: [],
      bossByKey: [],
      teamByKey: [],
      teamParentByKey: [],
      organizations: [],
      membersArchive: [],
      membersArchiveAll: [],
      incomplete: [],
      loadingMemberTable: true,
      loadingArchiveTable: true,
      supUserByTeam: [],
      houseByKey: [],
      webviewData: [],
      allArchiveData: [],
      managerMembers: [],
      orgChartView: {},
      orgChartModal: {},
      loadingOrgChartView: true,
    },
    mutations: {
      setDataMembers(state:any, result:any) {
        state.datamembers = result
      },
      setAllArchiveData(state:any, result:any) {
        state.allArchiveData = result
      },
      setManagerMembers(state:any, result:any) {
        state.managerMembers = result
      },
      setMember(state:any, result:any) {
        state.members = result
      },
      setTeamall(state:any, result:any) {
        state.teamall = result
      },
      setinputSearch(state:any,value:any) {
        state.inputSearch = value.keyword
        state.type = value.userstatus
      },
      setinputSearchArchive(state:any,value:any) {
        state.inputSearchArchive = value.keyword
      },
      setPage(state:any,result:any) {
        state.page = result
      },
      setPageArchive(state:any,result:any) {
        state.pagearchive = result
      },
      setType(state:any,result:any) {
        state.type = result
      },
      setSortfield(state:any,result:any) {
        state.sortfield = result
      },
      setSortfieldArchive(state:any,result:any) {
        state.sortfieldarchive = result
      },
      setSortorder(state:any,result:any) {
        state.sortorder = result
      },
      setSortorderArchive(state:any,result:any) {
        state.sortorderarchive = result
      },
      setDataExport(state:any, result:any) {
        state.dataexport = result
      },
      setResults(state:any, result:any) {
        state.results = result
      },
      setResultsArchive(state:any, result:any) {
        state.resultsArchive = result
      },
      setModalMemberData(state:any, result:any) {
        state.modalMemberData = result
      },
      setMemberKey(state:any, result:any) {
        state.membersByKey = result
      },
      setMemberArchiveKey(state:any, result:any) {
        state.membersArchiveByKey = result
      },
      setBossKey(state:any, result:any) {
        state.bossByKey = result
      },
      setTeamKey(state:any, result:any) {
        state.teamByKey = result
      },
      setTeamParentKey(state:any, result:any) {
        state.teamParentByKey = result
      },
      setOrganizations(state: any, value: any) {
        state.organizations = value
      },
      setMemberArchive(state: any, value: any) {
        state.membersArchive = value
      },
      setMemberArchiveAll(state: any, value: any) {
        state.membersArchiveAll = value
      },
      setIncomplete(state: any, value: any) {
        state.incomplete = value
      },
      setLoadingMemberTable(state:any, result:any) {
        state.loadingMemberTable = result
      },
      setLoadingArchiveTable(state:any, result:any) {
        state.loadingArchiveTable = result
      },
      setLoadingOrgChartView(state:any, result:any) {
        state.loadingOrgChartView = result
      },
      setsupUserByTeam(state:any, result:any) {
        state.supUserByTeam = result
      },
      setHouseBykey(state:any, result:any) {
        state.houseByKey = result
      },
      setWebViewData(state:any, result:any) {
        state.webviewData = result
      },
      setOrgChartView(state:any, result:any) {
        state.orgChartView = result
      },
    },
    actions: {
      getOrganization({ commit,state, rootState }: any) {
        if(state.organizations.length == 0){
          firebase.firestore().collection('organization').where("company", "==", rootState.authen.user.company).get()
          .then(function (querySnapshot) {
            const organizations: Array<any> = [];
            querySnapshot.forEach((doc) => {
              const organization = doc.data()
              organization.key = doc.id
              organizations[organization.team_id] = organization
            });
            commit('setOrganizations', organizations)
          });
        }
      },
      async getTeamParentKeyData({commit,dispatch,state}:any, user:any){
        let teamIn:Array<any> = []
        firebase.database().ref().child('team').orderByChild('company').equalTo(`${user.company}`).once('value', snapshot => {
        const teams:Array<any> = [];
        const parent:Array<any> = [];
        snapshot.forEach((doc):any => {
            const team = doc.val()
            team.key = doc.key
            team.value = doc.val().name
            if(team.sup === undefined){
                team.sup = new Array()
            }
            let teamId = team.key
            let arrTeam = state.organizations[teamId];
            if(arrTeam){
                if (arrTeam.parent) {
                    if (teamIn[teamId] === undefined) {
                        teamIn[teamId] = new Array();
                    }
                    teamIn[teamId][teamId] = true;
                    teamIn[teamId] = globalfunc.getTeamOfParent(arrTeam.parent,teamIn[teamId]);
                    for (const k in teamIn[teamId]) {
                        const userTeam = state.supUserByTeam[k]
                        for (const x in userTeam) {
                          if(userTeam[x].email){
                            let userTeamKey:any = userTeam[x].email.replace(/\./g, "||")
                            team.sup = _.concat(team.sup, state.membersByKey[userTeamKey]);
                          }
                        }
                    }
                }
            }else{
                const userTeam = state.supUserByTeam[teamId]
                for (const x in userTeam) {
                  if(userTeam[x].email){
                    let userTeamKey:any = userTeam[x].email.replace(/\./g, "||")
                    team.sup = _.concat(team.sup, state.membersByKey[userTeamKey]);
                  }
                }
            }
            team.sup = _.sortBy(team.sup, [function(o:any) { return o.firstname; }])
            const boss:any = _.filter(state.bossByKey, { 'team': team.key })
            if(boss.length > 0){
                let email:any = ""
                if(boss.length == 1){
                    email = boss[0].email.replace(/\./g, "||")
                }else{
                    let checkBigBoss = false
                    let arrManager:Array<any> = [];
                    for(const i in boss){
                        let mailBoss:any = boss[i].email.replace(/\./g, "||")
                        if(!state.membersByKey[mailBoss].boss){
                            email = mailBoss.replace(/\./g, "||")
                            checkBigBoss = true
                        }else{
                            arrManager.push({email:state.membersByKey[mailBoss].boss})
                        }
                    }
                    if(!checkBigBoss){
                        const checkCountManager:any = _.filter(arrManager, { 'email': arrManager[0].email })
                        if(arrManager.length == checkCountManager.length){
                            email = arrManager[0].email.replace(/\./g, "||")
                        }else{
                            const bossParent:any = _.filter(state.bossByKey, { 'team': team.parent })
                            if(bossParent.length > 0){
                                email = bossParent[0].email.replace(/\./g, "||")
                            }
                        }
                    }
                }
                if(email && state.membersByKey[email]){
                    team.boss_firstname = state.membersByKey[email].firstname
                    team.boss_lastname = state.membersByKey[email].lastname

                    if(state.membersByKey[email].profilepic_small){
                        team.pic = state.membersByKey[email].profilepic_small;
                    }else if (state.membersByKey[email].profilepic_crop){
                        team.pic = state.membersByKey[email].profilepic_crop;
                    }else if (state.membersByKey[email].profilepic){
                        team.pic = state.membersByKey[email].profilepic;
                    }else {
                        team.pic = '';
                    }
                }else{
                    team.boss_firstname = ''
                    team.boss_lastname = ''
                    team.pic = ''
                }
                
            }else{
                if(team.sup.length > 0){
                    let email:any = ""
                    if(team.sup.length == 1){
                        email = team.sup[0].email.replace(/\./g, "||")
                    }else {
                      let checkInMultipleTeam :any = _.filter(team.sup, { 'team': team.key })
                      if(checkInMultipleTeam.length == 1){
                          email = checkInMultipleTeam[0].email.replace(/\./g, "||")
                      }else{
                        let arrManager:Array<any> = [];
                        for(const i in team.sup){
                            let mailBoss:any = team.sup[i].email.replace(/\./g, "||")
                            if(state.membersByKey[mailBoss].boss){
                                arrManager.push({email:state.membersByKey[mailBoss].boss})
                            }
                        }
                        if(arrManager[0]){
                          const checkCountManager:any = _.filter(arrManager, { 'email': arrManager[0].email })
                          if(arrManager.length == checkCountManager.length){
                              email = arrManager[0].email.replace(/\./g, "||")
                          }else{
                              const bossParent:any = _.filter(state.bossByKey, { 'team': team.parent })
                              if(bossParent.length > 0){
                                  if(bossParent.length == 1){
                                      email = bossParent[0].email.replace(/\./g, "||")
                                  }else{
                                      let checkBigBoss2 = false
                                      let arrManager2:Array<any> = [];
                                      for(const i in bossParent){
                                          let mailBoss:any = bossParent[i].email.replace(/\./g, "||")
                                          if(!state.membersByKey[mailBoss].boss){
                                              email = mailBoss.replace(/\./g, "||")
                                              checkBigBoss2 = true
                                          }else{
                                              arrManager2.push({email:state.membersByKey[mailBoss].boss})
                                          }
                                      }
                                      if(!checkBigBoss2){
                                          const checkCountManager2:any = _.filter(arrManager2, { 'email': arrManager2[0].email })
                                          if(arrManager2.length == checkCountManager2.length){
                                              email = arrManager2[0].email.replace(/\./g, "||")
                                          }else{
                                              email = bossParent[0].email.replace(/\./g, "||")
                                          }
                                      }
                                  }
                              }
                          }
                        }
                      }
                    }
                    if(email && state.membersByKey[email]){
                        team.boss_firstname = state.membersByKey[email].firstname
                        team.boss_lastname = state.membersByKey[email].lastname
                        if(state.membersByKey[email].profilepic_small){
                            team.pic = state.membersByKey[email].profilepic_small;
                        }else if (state.membersByKey[email].profilepic_crop){
                            team.pic = state.membersByKey[email].profilepic_crop;
                        }else if (state.membersByKey[email].profilepic){
                            team.pic = state.membersByKey[email].profilepic;
                        }else {
                            team.pic = '';
                        }
                    }else{
                        team.boss_firstname = ''
                        team.boss_lastname = ''
                        team.pic = ''
                    }
                }else{
                    team.boss_firstname = ''
                    team.boss_lastname = ''
                    team.pic = ''
                }
            }
            teams[team.key] = team
        });
        commit('setTeamParentKey',teams)
      }).catch(error => {
          console.log(error)
      });
      },
      async getMember({commit,dispatch,state}:any, user:any){
        commit('setLoadingMemberTable',true)
        commit('setLoadingOrgChartView',true)
        commit('setMember',[])
        commit('setDataMembers',[])
        let dateNow = new Date()
        let thisYear = parseInt(format(dateNow, 'YYYY'))
        const dataMembers:Array<any> = []
        const users:Array<any> = [];
        const usersact:Array<any> = [];
        const usersinact:Array<any> = [];
        const usersnew:Array<any> = [];
        const usersinvited:Array<any> = [];
        const dataExport:Array<any> = [];
        const memberKey:Array<any> = [];
        const supUserByTeam:Array<any> = []
        let teamCheck:Array<any> = []
        let orgChartModal:any = {}
        orgChartModal.orgChartArr = new Array()
        orgChartModal.orgChartNoBoss = {}
        orgChartModal.orgChartNoBoss.children = new Array()
        let incomplete:Array<any> = [];
        const team = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
        let allUser = await getUsersByCompany(user.company)
        const company = (await firebase.database().ref(`/company/${user.company}`).once('value')).val()
        const allBoss:Array<any> = (await firebase.database().ref(`/boss/${user.company}`).once('value')).val()
        const allArchiveMember = (await firebase.database().ref('users_employee_exit').orderByChild("company").equalTo(user.company).once('value')).val()
        const AllArchiveMembers:Array<any> = []
        const dataManagerMembers:Array<any> = []
        _.forEach(allArchiveMember, (archiveData,key)=> {
          if(!allUser[key]){
            AllArchiveMembers[archiveData.email] = archiveData
          }
        });
        
        _.forEach(allUser, (arrData,key)=> {
          const u = arrData
          u.key = key
          u.value = u.firstname + " " + u.lastname
          let k_boss = u.boss.replace(/\./g, "||")
          if(k_boss && allUser[k_boss] != undefined){
            u.boss_name = allUser[k_boss]["firstname"] + " " + allUser[k_boss]["lastname"]
            u.boss_firstname = allUser[k_boss]["firstname"]
            u.boss_lastname = allUser[k_boss]["lastname"]
            u.boss_shortname = allUser[k_boss]["firstname"] + " " + allUser[k_boss]["lastname"].charAt(0)
            if(allUser[k_boss]['profilepic_small']){
              u.boss_pic = allUser[k_boss]['profilepic_small'];
            }else if (allUser[k_boss]['profilepic_crop']){
              u.boss_pic = allUser[k_boss]['profilepic_crop'];
            }else if (allUser[k_boss]['profilepic']){
              u.boss_pic = allUser[k_boss]['profilepic'];
            }else {
              u.boss_pic = "";
            }
          }
          if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
          if(u.team) u.team_color = (team[u.team]!=undefined)?team[u.team]["color"]:''
          if(u.profilepic_small){
            u.pic = u.profilepic_small;
          }else if (u.profilepic_crop){
            u.pic = u.profilepic_crop;
          }else if (u.profilepic){
            u.pic = u.profilepic;
          }else {
            u.pic = "";
          }

          if(u.profilepic) {
            u.large_pic = u.profilepic
          }else if(u.profilepic_crop) {
            u.large_pic = u.profilepic_crop
          }else if(u.profilepic_small){
            u.large_pic = u.profilepic_small
          }else {
            u.large_pic = ""
          }
          
          if((!u.boss || allUser[k_boss] == undefined) && (u.user_type != 'superleader' && u.user_type != 'superadmin' && u.user_type != 'leadership')){
            let checkDirectReport:Array<any> = [];
            checkDirectReport = _.filter(allUser, { 'boss': u.email })
            
            let _tmp:any = {}
            _tmp.directReport = checkDirectReport.length > 0 ? checkDirectReport.length : 0
            _tmp.firstname = u.firstname
            _tmp.lastname = u.lastname
            _tmp.fullname = u.value
            _tmp.pic = u.pic
            _tmp.id = u.email
            _tmp.teamColor = (u.team_color) ? u.team_color : ''
            _tmp.teamName = (u.team_name) ? u.team_name : ''
            _tmp.withOfNode = _tmp.directReport
            orgChartModal.orgChartNoBoss.children.push(_tmp)

            let _tmpObjUser:any = {}
            _tmpObjUser.type = 1
            _tmpObjUser.fullname = u.value
            _tmpObjUser.firstname = u.firstname
            _tmpObjUser.lastname = u.lastname
            _tmpObjUser.id = u.email
            _tmpObjUser.value = u.value
            _tmpObjUser.teamName = _tmp.teamName
            _tmpObjUser.refId = new Array()
            _tmpObjUser.refId.push(u.email)
            orgChartModal.orgChartArr.push(_tmpObjUser)
          }
          if(u.tutorial && u.tutorial == 'Y'){
            let dayActive = differenceInCalendarDays(dateNow, u.updated)
            if(dayActive > 30){
              u.status = 'inactive'
              u.to_now = format(u.updated,'MMM D, YYYY')
            }else{
              u.status = 'active'
              u.to_now = globalfunc.timeSince(u.updated)
            }
          }else if(u.invited){
            u.status = 'invited'
            u.to_now = globalfunc.timeSince(u.invited)
          }else{
            u.status = 'new'
          }

          if(company.medal && u.medal){
            _.forEach(u.medal, (value,key)=> {
              u.medal[key] = company.medal[key]
            });
          }
          if(u.status == 'active'){
            usersact.push(u)
          }else if(u.status == 'inactive') {
            usersinact.push(u)
          }else if(u.status == 'new'){
            usersnew.push(u)
          }else if(u.status == 'invited'){
            usersinvited.push(u)
          }
          if(supUserByTeam[u.team] === undefined){
            supUserByTeam[u.team] = new Array()
          }
          if(!u.boss && (u.user_type == 'superleader' || u.user_type == 'superadmin' || u.user_type == 'leadership')){
            u.inorder = -999
            incomplete.push(u)
            let checkDirectReport:Array<any> = [];
            checkDirectReport = _.filter(allUser, { 'boss': u.email })
            orgChartModal.orgChart = {}
            orgChartModal.orgChart.directReport = checkDirectReport.length > 0 ? checkDirectReport.length : 0
            orgChartModal.orgChart.firstname = u.firstname
            orgChartModal.orgChart.lastname = u.lastname
            orgChartModal.orgChart.fullname = u.value
            orgChartModal.orgChart.pic = u.pic
            orgChartModal.orgChart.id = u.email
            orgChartModal.orgChart.teamColor = (u.team_color) ? u.team_color : ''
            orgChartModal.orgChart.teamName = (u.team_name) ? u.team_name : ''
            orgChartModal.orgChart.withOfNode = orgChartModal.orgChart.directReport

            if(teamCheck[u.team] == undefined){
              teamCheck[u.team] = new Array()
              teamCheck[u.team] = true
              let _tmpObj:any = {}
              _tmpObj.type = 0
              _tmpObj.fullname = orgChartModal.orgChart.teamName
              _tmpObj.id = u.email
              _tmpObj.value = orgChartModal.orgChart.teamName
              _tmpObj.teamName = ''
              _tmpObj.refId = new Array()
              _tmpObj.refId.push(u.email)
              _tmpObj.teamMembers = new Array()
              let arrTeamMember:Array<any> = [];
              arrTeamMember = _.filter(allUser, { 'team': u.team })

              if(arrTeamMember.length > 0){
                _.forEach(arrTeamMember, (item_arrTeamMember,key_arrTeamMember)=> {
                  _tmpObj.teamMembers.push(item_arrTeamMember.email)
                });
              }
              orgChartModal.orgChartArr.push(_tmpObj)
            }
            let _tmpObjUser:any = {}
            _tmpObjUser.type = 1
            _tmpObjUser.fullname = u.value
            _tmpObjUser.firstname = u.firstname
            _tmpObjUser.lastname = u.lastname
            _tmpObjUser.id = u.email
            _tmpObjUser.value = u.value
            _tmpObjUser.teamName = orgChartModal.orgChart.teamName
            _tmpObjUser.refId = new Array()
            _tmpObjUser.refId.push(u.email)
            orgChartModal.orgChartArr.push(_tmpObjUser)
            
          }else if(!u.boss || !u.team || (u.boss && allUser[k_boss] == undefined) || (u.team && team[u.team] == undefined)){
            u.inorder = 0
            incomplete.push(u)
          }
          if(u.joined_tooltips === undefined){
            u.joined_tooltips = new Array()
          }
          if(u.workdate){
            u.joined = format(u.workdate,'MMMM D, YYYY')
            let arrJoined:Array<any> = [];
            arrJoined['year'] = differenceInCalendarYears(dateNow, u.workdate)
            let month = differenceInCalendarMonths(dateNow, setYear(u.workdate,thisYear))
            if(month < 0){
              arrJoined['month'] = month + 12
              arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
            }else{
              arrJoined['month'] = month
            }
            let day = parseInt(format(dateNow,'DD')) - parseInt(format(u.workdate,'DD'))
            if(day < 0){
              arrJoined['day'] = day + parseInt(format(lastDayOfMonth(addMonths(dateNow, -1)),'DD'));
              if(arrJoined['month'] > 0){
                arrJoined['month'] = arrJoined['month'] - 1
              }else{
                arrJoined['month'] = 12
                arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
              }
            }else{
              arrJoined['day'] = day
            }
            u.joined_tooltips.push(arrJoined)
          }
          if(u.boss && AllArchiveMembers[u.boss]){
            if(dataManagerMembers[u.boss] === undefined){
              dataManagerMembers[u.boss] = new Array()
            }
            dataManagerMembers[u.boss].push(u)
          }
          const dataEx = {
            'First Name': u.firstname,
            'Last Name': u.lastname,
            'Email Address': u.email,
            'Team Name': u.team_name,
            'Direct Manager (E-mail)': u.boss,
            'Coins': u.coin,
            'Gems': u.gem,
            'Active (Installed)': (u.tutorial == 'Y') ? "Yes" : "no",
            'Last Visit': u.updated,
            'Create Date': u.createdatetime,
            'Modified Date': u.modifydatetime
          }
          dataExport.push(dataEx)
          memberKey[u.key] = u
          supUserByTeam[u.team].push(u)
          users.push(u)
        });
        if(orgChartModal.orgChart && orgChartModal.orgChart.id){
          let getChild:Array<any> = [];
          getChild = _.filter(users, { 'boss': orgChartModal.orgChart.id })
          if(getChild.length > 0){
            orgChartModal.orgChart.children = new Array()
            _.forEach(getChild, (item,key)=> {
              if(memberKey[item.email.replace(/\./g, "||")] != undefined){
                let _tmp:any = {}
                let _tmpObj:any = {}
                let checkDirectReport:Array<any> = [];
                checkDirectReport = _.filter(users, { 'boss': item.email })
                _tmp.directReport = checkDirectReport.length > 0 ? checkDirectReport.length : 0
                _tmp.firstname = item.firstname
                _tmp.lastname = item.lastname
                _tmp.fullname = item.value
                _tmp.pic = item.pic
                _tmp.id = item.email
                _tmp.teamColor = (item.team_color) ? item.team_color : ''
                _tmp.teamName = (item.team_name) ? item.team_name : ''
                _tmp.withOfNode = _tmp.directReport
                orgChartModal.orgChart.children.push(_tmp)

                let _tmpObjUser:any = {}
                _tmpObjUser.type = 1
                _tmpObjUser.fullname = item.value
                _tmpObjUser.firstname = item.firstname
                _tmpObjUser.lastname = item.lastname
                _tmpObjUser.id = item.email
                _tmpObjUser.value = item.value
                _tmpObjUser.teamName = item.team_name
                _tmpObjUser.refId = new Array()
                _tmpObjUser.refId.push(orgChartModal.orgChart.id)
                _tmpObjUser.refId.push(item.email)
                orgChartModal.orgChartArr.push(_tmpObjUser)

                if(teamCheck[item.team] == undefined){
                  teamCheck[item.team] = new Array()
                  teamCheck[item.team] = true
                  _tmpObj.type = 0
                  _tmpObj.fullname = _tmp.teamName
                  _tmpObj.id = item.email
                  _tmpObj.value = _tmp.teamName
                  _tmpObj.teamName = ''
                  _tmpObj.refId = new Array()
                  _tmpObj.refId.push(orgChartModal.orgChart.id)
                  _tmpObj.refId.push(item.email)
                  _tmpObj.teamMembers = new Array()
                  let arrTeamMember:Array<any> = [];
                  arrTeamMember = _.filter(users, { 'team': item.team })
                  if(arrTeamMember.length > 0){
                    _.forEach(arrTeamMember, (item_arrTeamMember,key_arrTeamMember)=> {
                      _tmpObj.teamMembers.push(item_arrTeamMember.email)
                    });
                  }
                  orgChartModal.orgChartArr.push(_tmpObj)
                }
                let _tmpChildren:Array<any> = [];
                _tmpChildren = _.filter(users, { 'boss': item.email })
                if(_tmpChildren.length > 0){
                  var promise1 = new Promise(function(resolve, reject) {
                    const children = dispatch('getChildren', {children: _tmpChildren,allUser: users, memberKey: memberKey, refId: _tmpObj.refId, teamCheck: teamCheck, orgChartModal: orgChartModal});
                    resolve(children);
                  });
                  Promise.all([promise1]).then((values)=> {
                    const data1:any = values[0]
                    orgChartModal.orgChart.children[key]['children'] = new Array()
                    orgChartModal.orgChart.children[key]['children'] = data1
                });
                }else{
                  orgChartModal.orgChart.children[key]['children'] = {}
                }
              }
            });
          }
        }
        let _users:Array<any> = [];
        _users = _.sortBy(users, [function(o:any) { return o.workdate; }])
        let orderJoin = 1
        _.forEach(_users, (item,key)=> {
          if(item.workdate){
            _users[key].order_join = orderJoin
            orderJoin++
          }
        });
        let checkOrder:Array<any> = [];
        if(incomplete.length > 0){
          checkOrder = _.filter(incomplete, { 'inorder': -999 } as object)
          if(checkOrder.length > 1 || incomplete.length > 1 || (incomplete.length == 1 && checkOrder.length == 0)){
            _users = _.sortBy(_users, [function(o:any) { return o.inorder; }, function(o:any) { return o.firstname; }])
          }else{
            _users = _.sortBy(_users, [function(o:any) { return o.firstname; }])
          }
        }else{
          _users = _.sortBy(_users, [function(o:any) { return o.firstname; }])
        }
        orgChartModal.orgChartArr = _.sortBy(orgChartModal.orgChartArr, ["type", "fullname"]);
        commit('setOrgChartView',orgChartModal)
        commit('setAllArchiveData',AllArchiveMembers)
        commit('setManagerMembers',dataManagerMembers)
        commit('setResults',_users)
        commit('setMember', _users.slice(0, state.size_page))
        commit('setMemberKey', memberKey)
        commit('setBossKey', allBoss)
        commit('setTeamKey', team)
        commit('setsupUserByTeam', supUserByTeam)
        commit('setIncomplete',incomplete)
        dataMembers['membersall'] = _users
        dataMembers['membersact'] = usersact
        dataMembers['membersinact'] = usersinact
        dataMembers['membersnew'] = usersnew
        dataMembers['membersinvited'] = usersinvited
        commit('setDataMembers',dataMembers)
        commit('setDataExport', dataExport)
        commit('setLoadingMemberTable',false)
        commit('setLoadingOrgChartView',false)
        if(state.inputSearch){
          dispatch('searchMembers',state.inputSearch)
        }
      },
      async getChildren({ dispatch, state }: any, obj:any){
        const arrData: Array<any> = [];
        const allUser = obj.allUser
        const children = obj.children
        const memberKey = obj.memberKey
        const refId = obj.refId
        let teamCheck = obj.teamCheck
        let orgChartModal = obj.orgChartModal
        if(children.length > 0){
          _.forEach(children, (item,key)=> {
            if(memberKey[item.email.replace(/\./g, "||")] != undefined){
              let _tmp:any = {}
              let _tmpObj:any = {}
              let checkDirectReport:Array<any> = [];
              checkDirectReport = _.filter(allUser, { 'boss': item.email })
              _tmp.directReport = checkDirectReport.length > 0 ? checkDirectReport.length : 0
              _tmp.firstname = item.firstname
              _tmp.lastname = item.lastname
              _tmp.fullname = item.value
              _tmp.pic = item.pic
              _tmp.id = item.email
              _tmp.teamColor = (item.team_color) ? item.team_color : ''
              _tmp.teamName = (item.team_name) ? item.team_name : ''
              _tmp.withOfNode = _tmp.directReport > 0 ? _tmp.directReport : 1
              arrData.push(_tmp)

              let _tmpObjUser:any = {}
              _tmpObjUser.type = 1
              _tmpObjUser.fullname = item.value
              _tmpObjUser.firstname = item.firstname
              _tmpObjUser.lastname = item.lastname
              _tmpObjUser.id = item.email
              _tmpObjUser.value = item.value
              _tmpObjUser.teamName = item.team_name
              _tmpObjUser.refId = new Array()
              _.forEach(refId, (item,key)=> {
                _tmpObjUser.refId.push(item)
              });
              orgChartModal.orgChartArr.push(_tmpObjUser)

              if(refId){
                if(teamCheck[item.team] == undefined){
                  teamCheck[item.team] = new Array()
                  teamCheck[item.team] = true
                  _tmpObj.type = 0
                  _tmpObj.fullname = _tmp.teamName
                  _tmpObj.id = _tmp.id
                  _tmpObj.value = _tmp.teamName
                  _tmpObj.teamName = ''
                  _tmpObj.refId = new Array()
                  _.forEach(refId, (item,key)=> {
                    _tmpObj.refId.push(item)
                  });
                  _tmpObj.refId.push(_tmp.id)
                  _tmpObj.teamMembers = new Array()
                  let arrTeamMember:Array<any> = [];
                  arrTeamMember = _.filter(allUser, { 'team': item.team })
                  if(arrTeamMember.length > 0){
                    _.forEach(arrTeamMember, (item_arrTeamMember,key_arrTeamMember)=> {
                      _tmpObj.teamMembers.push(item_arrTeamMember.email)
                    });
                  }
                  orgChartModal.orgChartArr.push(_tmpObj)
                }
              }
              let _tmpChildren:Array<any> = [];
              _tmpChildren = _.filter(allUser, { 'boss': item.email })
              if(_tmpChildren.length > 0){
                var promise1 = new Promise(function(resolve, reject) {
                  const children = dispatch('getChildren', {children: _tmpChildren,allUser: allUser, memberKey: memberKey, refId: _tmpObj.refId, teamCheck: teamCheck, orgChartModal: orgChartModal});
                  resolve(children);
                });
                Promise.all([promise1]).then((values)=> {
                  const data1:any = values[0]
                  arrData[key]['children'] = new Array()
                  arrData[key]['children'] = data1
                });
              }else{
                arrData[key]['children'] = {}
              }
            }
          });
        }
        return arrData
      },
      async getTeamAll({commit,dispatch,state}:any, user:any){
        firebase.database().ref('team').orderByChild("company").equalTo(`${user.company}`).once('value', snapshot => {
          const teamData:Array<any> = [];
          snapshot.forEach((arrData):any => {
            const u = arrData.val()
            u.key = arrData.key
            u.value = arrData.val().name
            teamData.push(u)
            
          });
          commit('setTeamall', _.sortBy(teamData, [function(o:any) { return o.name; }]))
        }).catch(error => {
          console.log(error)
        });
      },
      currentChange({commit,state}:any,page:any){
        var size = state.size_page
        var start_row = (page-1) * size
        var end_row = ((page-1) * size)+size
        let member: Array<any> = [];
        if(state.type == 'active'){
          member.push(state.datamembers['membersact'])
        }else if(state.type == 'inactive'){
          member.push(state.datamembers['membersinact'])
        }else if(state.type == 'new'){
          member.push(state.datamembers['membersnew'])
        }else if(state.type == 'invited'){
          member.push(state.datamembers['membersinvited'])
        }else{
          member.push(state.datamembers['membersall'])
        }
        if (state.inputSearch.length > 2){
          if (member.length > 0){
            var re = new RegExp(state.inputSearch, 'gi')
            var response = _.filter(member[0], (item): any => {
              if (item.firstname.match(re)) {
                return true
              } else if (item.lastname != undefined && item.lastname.match(re)) {
                return true
              } else if (item.value != undefined && (item.value.match(re))) {
                return true
              } else if (item.email != undefined && item.email.match(re)) {
                return true
              } else if (item.team_name != undefined && item.team_name.match(re)) {
                return true
              }
            });
            member[0] = response
          }
        }
        var field = state.sortfield
        let checkOrder:Array<any> = [];
        let _users:Array<any> = [];
        if(state.incomplete.length > 0){
          checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
          if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
            _users = _.orderBy(member[0], ["inorder",field], ["asc",state.sortorder]);
          }else{
            _users = _.orderBy(member[0], [field], [state.sortorder]);
          }
        }else{
          _users = _.orderBy(member[0], [field], [state.sortorder]);
        }
        // var _users = _.orderBy(member[0], ["inorder",field], ["asc",state.sortorder]);
        commit('setPage',page)
        commit('setMember', _users.slice(start_row,end_row))
      },
      archiveCurrentChange({commit,state}:any,page:any){
        var size = state.size_page
        var start_row = (page-1) * size
        var end_row = ((page-1) * size)+size
        let member: Array<any> = [];
        member.push(state.membersArchiveAll)
        if (state.inputSearchArchive.length > 2){
          if (member.length > 0){
            var re = new RegExp(state.inputSearchArchive, 'gi')
            var response = _.filter(member[0], (item): any => {
              if (item.firstname.match(re)) {
                return true
              } else if (item.lastname != undefined && item.lastname.match(re)) {
                return true
              } else if (item.value != undefined && (item.value.match(re))) {
                return true
              } else if (item.email != undefined && item.email.match(re)) {
                return true
              } else if (item.team_name != undefined && item.team_name.match(re)) {
                return true
              }
            });
            member[0] = response
          }
        }
        
        var field = state.sortfieldarchive
        var _users = _.orderBy(member[0], [field], [state.sortorderarchive]);
        commit('setPageArchive',page)
        commit('setMemberArchive', _users.slice(start_row,end_row))
      },
      async createMember({commit,rootState,dispatch,state}:any,obj:any){
        let form = obj.form
        let invite = obj.invite
        commit('setLoadingMemberTable',true)
        commit('setMember',[])
        let team:any = ""
        const teamMaster = (await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
        const allUser = await getUsersByCompany(rootState.authen.user.company)
        let teamFind = _.findKey(teamMaster, item => {
          return item.name.toLowerCase() === form.dispteam.toLowerCase();
        });

        let bossKey = form.boss.replace(/\./g, "||")
        let parentId = (allUser[bossKey] && allUser[bossKey].team)?allUser[bossKey].team : ""
        if(teamFind && teamFind !== undefined){
          team = teamFind
          if(state.teamByKey[team] && state.teamByKey[team].parent == '' && parentId && team !== parentId){
            firebase.database().ref(`team/${team}`).update({
              parent:parentId,
              updated:format(new Date(), 'YYYY-MM-DD HH:mm')
            }).then(()=>{
              firebase.database().ref(`/genorganize`).push({
                  company:rootState.authen.user.company
              });
            });
          }
        }else{
          team = firebase.database().ref('team').push().key;
          firebase.database().ref(`team/${team}`).update({
            name:form.dispteam,
            parent:parentId,
            company:rootState.authen.user.company,
            updated:format(new Date(), 'YYYY-MM-DD HH:mm')
          }).then(()=>{
            firebase.database().ref(`/genorganize`).push({
                company:rootState.authen.user.company
            });
            /*save logs*/
            dispatch('authen/addLogs', {
              company: rootState.authen.user.company,
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                id: team,
                table: 'team',
                status: 'add',
                user: rootState.authen.user.email
            }, {root:true})
          });
        }
        
        let ctemail = form.email.toLowerCase()
        ctemail = ctemail.replace(/ /g, "")
        const newId = ctemail.replace(/\./g, "||")
        const userComp = rootState.authen.user.company
        const userBoss = form.boss
        firebase.database().ref(`/users`).child(newId).set({
            firstname:form.firstname.trim(),
            lastname:form.lastname.trim(),
            email:ctemail,
            company:userComp,
            team,
            boss:userBoss,
            language:form.language,
            user_type:form.user_type,
            gem:0,
            coin:0,
            powerup:{
              fivecoins:"14",
              threecoins:"7",
            },
            profilepic:"",
            address:"",
            mobile:"",
            phone:"",
            updated:format(new Date(), 'YYYY-MM-DD HH:mm'),
            createdatetime:format(new Date(), 'YYYY-MM-DD HH:mm'),
            modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
        }).then(()=>{
          if(userBoss){
            firebase.database().ref(`/genboss`).push({
              company:userComp
            })
          }
        }).then(()=>{
          if(invite == true){
            firebase.database().ref(`/user_invite`).push({
              email:ctemail
            }).then(()=>{
              let Id = ctemail.replace(/\./g, "||")
              firebase.database().ref(`/users/${Id}`).update({
                invited:format(new Date(), 'YYYY-MM-DD HH:mm:ss')
              })
            })
          }
        }).then(()=>{
          dispatch('sendQuestionNew',{
              newId,
              email:ctemail,
              company:userComp,
              team,
            });
          }).then(function() {
            if(!teamFind || teamFind == undefined || teamFind == ''){
              dispatch('getTeamAll',rootState.authen.user)
            }
          });
        },
        async sendQuestionNew({commit,rootState,dispatch}:any, value:any){
          const company = (await firebase.database().ref(`company/${value.company}`).once('value')).val()
          const category = (await firebase.database().ref('category').orderByChild("status").equalTo("Y").once('value')).val()
          const questions = (await firebase.database().ref('questions').once('value')).val()
          const timeZone = (company.timezone && company.timezone !== undefined) ? Number(company.timezone) : 7;
          const day = format(new Date().setUTCHours(timeZone), 'dddd');
          if(day !== 'Saturday' && day !== 'Sunday'){
              const datenow = format(new Date(), 'YYYY-MM-DD');
              firebase.firestore().collection('log_company').where('date', '==', datenow).where('type', '==', 'users_questions').get()
                .then(function (querySnapshot) {
                    if (querySnapshot.empty) {
                      console.log('log_company no matching documents.');
                      /*save logs*/
                      dispatch('authen/addLogs', {
                        company: value.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: value.newId,
                        table: 'users',
                        status: 'add',
                        user: rootState.authen.user.email
                      }, {root:true}).then(function() {
                        commit('setPage',1)
                        dispatch('getMember',rootState.authen.user)
                      });
                    }else {
                      let company_list = [];
                      querySnapshot.forEach(function (doc) {
                        const data = doc.data();
                        company_list = data.company_list;
                      });
                      const company_ck = _.indexOf(company_list, value.company);
                      if(company_ck > -1){
                        const get_questions_arr = [`-Kgs61AHOnpJ3rfyQr6t`, `-Lww4xIIHQ5hmxEhR2nE`];
                        const optType = {'Multiple Choice': 0, 'Text Area Field': 2, 'Scale': 5};
                        let i = 0;
                        for (const questid in get_questions_arr) {
                            const quest = get_questions_arr[questid];
                            const dataArr = {};
                            dataArr[`calculate`] = '1';
                            dataArr[`quest_id`] = quest;
                            dataArr[`genus`] = questions[quest][`genus`];
                            dataArr[`quest_name`] = questions[quest][`question`];
                            dataArr[`quest_name_en`] = questions[quest][`question_en`];
                            dataArr[`type`] = questions[quest][`type`];
                            if (dataArr[`type`] === 'Multiple Choice') {
                                dataArr[`m_choice`] = (questions[quest][`m_choice`][`th`] !== undefined) ? questions[quest][`m_choice`][`th`].join(',') : '';
                                dataArr[`m_choice_en`] = (questions[quest][`m_choice`][`en`] !== undefined) ? questions[quest][`m_choice`][`en`].join(',') : '';
                                dataArr[`m_choice_points`] = (questions[quest][`m_choice`][`points`] !== undefined) ? questions[quest][`m_choice`][`points`].join(',') : '';
                                dataArr[`pages`] = (questions[quest][`m_choice`][`th`].length > 2) ? optType[questions[quest][`type`]] : 1;
                            } else {
                                dataArr[`less_txt`] = (questions[quest][`less_txt`] !== undefined) ? questions[quest][`less_txt`] : '';
                                dataArr[`less_txt_en`] = (questions[quest][`less_txt_en`] !== undefined) ? questions[quest][`less_txt_en`] : '';
                                dataArr[`max_txt_en`] = (questions[quest][`max_txt_en`] !== undefined) ? questions[quest][`max_txt_en`] : '';
                                dataArr[`max_txt`] = (questions[quest][`max_txt`] !== undefined) ? questions[quest][`max_txt`] : '';
                                dataArr[`points`] = (questions[quest][`points`] !== undefined) ? questions[quest][`points`] * 1 : '';
                                dataArr[`pages`] = optType[questions[quest][`type`]];
                            }
                            dataArr[`category`] = category[questions[quest][`category`]][`category`];
                            dataArr[`dark_color`] = category[questions[quest][`category`]][`dark_color`];
                            dataArr[`light_color`] = category[questions[quest][`category`]][`light_color`];
                            dataArr[`image`] = category[questions[quest][`category`]][`filepath`];
                            dataArr[`users`] = value.email;
                            dataArr[`date`] = datenow;
                            dataArr[`status`] = 'open';
                            dataArr[`updated`] = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                            dataArr[`company`] = value.company;
                            dataArr[`team`] = value.team;
                            dataArr[`parent`] = '';
                            dataArr[`priority`] = (quest === '-Kgs61AHOnpJ3rfyQr6t') ? 3 : 4;

                            firebase.firestore().collection('users_questions').add(dataArr);

                            if(i === 1) {
                              // console.log(rootState.authen.user.email);
                              /*save logs*/
                              dispatch('authen/addLogs', {
                                company: value.company,
                                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                                id: value.newId,
                                table: 'users',
                                status: 'add',
                                user: rootState.authen.user.email
                              }, {root:true}).then(function() {
                                commit('setPage',1)
                                dispatch('getMember',rootState.authen.user)
                              });
                            }
                            i++;
                          }
                        }else {
                          /*save logs*/
                          dispatch('authen/addLogs', {
                            company: value.company,
                            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                            id: value.newId,
                            table: 'users',
                            status: 'add',
                            user: rootState.authen.user.email
                          }, {root:true}).then(function() {
                            commit('setPage',1)
                            dispatch('getMember',rootState.authen.user)
                          });
                        }
                    }
              });
          }else {
            /*save logs*/
            dispatch('authen/addLogs', {
              company: value.company,
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              id: value.newId,
              table: 'users',
              status: 'add',
              user: rootState.authen.user.email
            }, {root:true}).then(function() {
              commit('setPage',1)
              dispatch('getMember',rootState.authen.user)
            });
          }
        },
        async updateMember({commit,rootState,dispatch,state}:any,value:any){
          commit('setLoadingMemberTable',true)
          commit('setMember',[])
          const tmp_boss = value.form.tmp_boss
          const boss = value.form.boss
          const userComp = rootState.authen.user.company
          let team:any = ""
          const teamMaster = (await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
          const allUser = await getUsersByCompany(rootState.authen.user.company)
          let teamFind = _.findKey(teamMaster, item => {
            return item.name.toLowerCase() === value.form.dispteam.toLowerCase();
          });
          
          let bossKey = boss.replace(/\./g, "||")
          let parentId = (allUser[bossKey] && allUser[bossKey].team)?allUser[bossKey].team : ""
          if(teamFind && teamFind !== undefined){
            team = teamFind
            if(state.teamByKey[team] && state.teamByKey[team].parent == '' && parentId && team !== parentId){
              firebase.database().ref(`team/${team}`).update({
                parent:parentId,
                updated:format(new Date(), 'YYYY-MM-DD HH:mm')
              }).then(()=>{
                firebase.database().ref(`/genorganize`).push({
                    company:rootState.authen.user.company
                });
              });
            }
          }else{
            team = firebase.database().ref('team').push().key;
            firebase.database().ref(`team/${team}`).update({
              name:value.form.dispteam,
              parent:parentId,
              company:rootState.authen.user.company,
              updated:format(new Date(), 'YYYY-MM-DD HH:mm')
            }).then(()=>{
              firebase.database().ref(`/genorganize`).push({
                  company:rootState.authen.user.company
              });
              /*save logs*/
              dispatch('authen/addLogs', {
                company: rootState.authen.user.company,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: team,
                  table: 'team',
                  status: 'add',
                  user: rootState.authen.user.email
              }, {root:true})
            });
          }
          firebase.database().ref(`/users/${value.id}`).update({
              firstname:value.form.firstname.trim(),
              lastname:value.form.lastname.trim(),
              team:team,
              boss:boss,
              language:value.form.language,
              user_type:value.form.user_type,
              // updated:format(new Date(), 'YYYY-MM-DD HH:mm'),
              modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
          }).then(()=>{
            // if(tmp_boss != boss){
              firebase.database().ref(`/genboss`).push({
                company:userComp
              })
            // }
        }).then(()=>{
            /*save logs*/
            dispatch('authen/addLogs', {
              company: userComp,
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              id: value.id,
              table: 'users',
              status: 'edit',
              user: rootState.authen.user.email
            }, {root:true}).then(function() {
              if(!teamFind || teamFind == undefined || teamFind == ''){
                dispatch('getTeamAll',rootState.authen.user)
              }
              commit('setPage',1)
              dispatch('getMember',rootState.authen.user)
            });
          });
        },
        searchMembers({commit,state}:any,value:string){
          let field = state.sortfield
          let order = state.sortorder
          commit('setPage',1)
          const member: Array<any> = [];
          if(state.type == 'active'){
            member.push(state.datamembers['membersact'])
          }else if(state.type == 'inactive'){
            member.push(state.datamembers['membersinact'])
          }else if(state.type == 'new'){
            member.push(state.datamembers['membersnew'])
          }else if(state.type == 'invited'){
            member.push(state.datamembers['membersinvited'])
          }else{
            member.push(state.datamembers['membersall'])
          }
          
          if(field == 'name')
            field = 'value'

          if(order == 'ascending' || order == 'asc')
            order = 'asc'
          else
            order = 'desc'

          let checkOrder:Array<any> = [];
          let _users:Array<any> = [];
          if (value.length > 2){
            if (member.length > 0){
              var re = new RegExp(value, 'gi')
              var response = _.filter(member[0], (item): any => {
                if (item.firstname.match(re)) {
                  return true
                } else if (item.lastname != undefined && item.lastname.match(re)) {
                  return true
                } else if (item.value != undefined && (item.value.match(re))) {
                  return true
                } else if (item.email != undefined && item.email.match(re)) {
                  return true
                } else if (item.team_name != undefined && item.team_name.match(re)) {
                  return true
                }
              });
              if(state.incomplete.length > 0){
                checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
                if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
                  _users = _.orderBy(response, ["inorder",field], ["asc",order]);
                }else{
                  _users = _.orderBy(response, [field], [order]);
                }
              }else{
                _users = _.orderBy(response, [field], [order]);
              }
              // let response_sort = _.orderBy(response, ["inorder",field], ["asc",order]);
              commit('setResults', _users)
              commit('setMember', _users.slice(0,state.size_page))
            }
          }else if(value.length == 0){
            if(state.incomplete.length > 0){
              checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
              if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
                _users = _.orderBy(member[0], ["inorder",field], ["asc",order]);
              }else{
                _users = _.orderBy(member[0], [field], [order]);
              }
            }else{
              _users = _.orderBy(member[0], [field], [order]);
            }
            // let response_sort = _.orderBy(member[0], ["inorder",field], ["asc",order]);
            commit('setResults', _users)
            commit('setMember', _users.slice(0,state.size_page))
          }
        },
        searchMembersArchive({commit,state}:any,value:string){
          let field = state.sortfieldarchive
          let order = state.sortorderarchive
          commit('setPageArchive',1)
          const member: Array<any> = [];
          member.push(state.membersArchiveAll)
          
          if(field == 'name')
            field = 'value'

          if(order == 'ascending' || order == 'asc')
            order = 'asc'
          else
            order = 'desc'

          if (value.length > 2){
            if (member.length > 0){
              var re = new RegExp(value, 'gi')
              var response = _.filter(member[0], (item): any => {
                if (item.firstname.match(re)) {
                  return true
                } else if (item.lastname != undefined && item.lastname.match(re)) {
                  return true
                } else if (item.value != undefined && (item.value.match(re))) {
                  return true
                } else if (item.email != undefined && item.email.match(re)) {
                  return true
                } else if (item.team_name != undefined && item.team_name.match(re)) {
                  return true
                }
              });
              let response_sort = _.orderBy(response, [field], [order]);
              commit('setResultsArchive', response_sort)
              commit('setMemberArchive', response_sort.slice(0,state.size_page))
            }
          }else if(value.length == 0){
            let response_sort = _.orderBy(member[0], [field], [order]);
            commit('setResultsArchive', response_sort)
            commit('setMemberArchive', response_sort.slice(0,state.size_page))
          }
        },
        statusChange({commit,state}:any,type:string){
          let field = state.sortfield
          let order = state.sortorder
          commit('setType',type)
          commit('setPage',1)
          const member: Array<any> = [];
          if(state.type == 'active'){
            member.push(state.datamembers['membersact'])
          }else if(state.type == 'inactive'){
            member.push(state.datamembers['membersinact'])
          }else if(state.type == 'new'){
            member.push(state.datamembers['membersnew'])
          }else if(state.type == 'invited'){
            member.push(state.datamembers['membersinvited'])
          }else{
            member.push(state.datamembers['membersall'])
          }
          if(field == 'name')
            field = 'value'

          if(order == 'ascending' || order == 'asc')
            order = 'asc'
          else
            order = 'desc'

          let checkOrder:Array<any> = [];
          let _users:Array<any> = [];
          if(state.incomplete.length > 0){
            checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
            if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
              _users = _.orderBy(member[0], ["inorder",field], ["asc",order]);
            }else{
              _users = _.orderBy(member[0], [field], [order]);
            }
          }else{
            _users = _.orderBy(member[0], [field], [order]);
          }
          // var _users = _.orderBy(member[0], ["inorder",field], ["asc",order]);
          commit('setResults',_users)
          commit('setMember', _users.slice(0,state.size_page))
        },
        updateUserType({commit}:any,value:any){
          firebase.database().ref(`/users/${value.id}`).update({
              user_type:value.type,
              modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
          }).then(()=>{
            console.log("success");
          });
        },
        inviteMember({commit,rootState,dispatch}:any,email:any){
          firebase.database().ref(`/user_invite`).push({
            email:email
          }).then(()=>{
            let Id = email.replace(/\./g, "||")
            firebase.database().ref(`/users/${Id}`).update({
              invited:format(new Date(), 'YYYY-MM-DD HH:mm:ss')
            }).then(()=>{
              commit('setPage',1)
              dispatch('getMember',rootState.authen.user)
            });
          })
        },
        inviteArrMember({commit,rootState,dispatch}:any,obj:any){
          if(obj.length > 0){
            _.forEach(obj, (item,key)=> {
              firebase.database().ref(`/user_invite`).push({
                email:item.email
              }).then(()=>{
                let Id = item.email.replace(/\./g, "||")
                firebase.database().ref(`/users/${Id}`).update({
                  invited:format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                });
              });
            });
            commit('setPage',1)
            dispatch('getMember',rootState.authen.user)
          }
        },
        archiveMember({commit,rootState,dispatch}:any,id:any){
          if(id != undefined){
            commit('setLoadingMemberTable',true)
            commit('setMember',[])
            let users = firebase.database().ref('users/' + id).once('value', snapshot => {
              const data = snapshot.val();
              if(data != undefined){
                data.exitdated = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                firebase.database().ref('users_employee_exit/' + id).set(data, function (error) {
                  if (error) {
                    console.log('The write failed...')
                  } else {
                    firebase.database().ref('users').child(id).remove();
                  }
                }).then(()=>{
                  /*save logs*/
                  dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: id,
                    table: 'users',
                    status: 'remove',
                    type: 'user_exit',
                    user: rootState.authen.user.email
                  }, {root:true}).then(function() {
                    commit('setPage',1)
                    dispatch('getMember',rootState.authen.user)
                  });
                });
              }
            }).catch(error => {
              console.log(error)
            });
          }
        },
        archiveArrMember({commit,rootState,dispatch}:any,obj:any){
          if(obj.length > 0){
            _.forEach(obj, (item,key)=> {
              let id = item.key
              if(id != undefined){
                let users = firebase.database().ref('users/' + id).once('value', snapshot => {
                  const data = snapshot.val();
                  if(data != undefined){
                    data.exitdated = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                    firebase.database().ref('users_employee_exit/' + id).set(data, function (error) {
                      if (error) {
                        console.log('The write failed...')
                      } else {
                        firebase.database().ref('users').child(id).remove();
                      }
                    }).then(()=>{
                      /*save logs*/
                      dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: id,
                        table: 'users',
                        status: 'remove',
                        type: 'user_exit',
                        user: rootState.authen.user.email
                      }, {root:true})
                    });
                  }
                }).catch(error => {
                  console.log(error)
                });
              }
            });
            commit('setPage',1)
            dispatch('getMember',rootState.authen.user)
          }
        },
        unArchiveMember({commit,rootState,dispatch}:any,id:any){
          if(id != undefined){
            commit('setLoadingArchiveTable',true)
            commit('setMemberArchive', [])
            let users = firebase.database().ref('users_employee_exit/' + id).once('value', snapshot => {
              const data = snapshot.val();
              if(data != undefined){
                delete data.exitdated
                firebase.database().ref('users/' + id).set(data, function (error) {
                  if (error) {
                    console.log('The write failed...')
                  } else {
                    firebase.database().ref('users_employee_exit').child(id).remove();
                  }
                }).then(()=>{
                  /*save logs*/
                  dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: id,
                    table: 'users_employee_exit',
                    status: 'remove',
                    type: 'user_unarchive',
                    user: rootState.authen.user.email
                  }, {root:true}).then(function() {
                    commit('setPageArchive',1)
                    dispatch('getArchiveData',rootState.authen.user)
                    
                    commit('setPage',1)
                    dispatch('getMember',rootState.authen.user)
                  });
                });
              }
            }).catch(error => {
              console.log(error)
            });
          }
        },
        unArchiveArrMember({commit,rootState,dispatch}:any,obj:any){
          if(obj.length > 0){
            commit('setLoadingArchiveTable',true)
            commit('setMemberArchive', [])
            _.forEach(obj, (item,key)=> {
              let id = item.key
              if(id != undefined){
                let users = firebase.database().ref('users_employee_exit/' + id).once('value', snapshot => {
                  const data = snapshot.val();
                  if(data != undefined){
                    delete data.exitdated
                    firebase.database().ref('users/' + id).set(data, function (error) {
                      if (error) {
                        console.log('The write failed...')
                      } else {
                        firebase.database().ref('users_employee_exit').child(id).remove();
                      }
                    }).then(()=>{
                      /*save logs*/
                      dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: id,
                        table: 'users_employee_exit',
                        status: 'remove',
                        type: 'user_unarchive',
                        user: rootState.authen.user.email
                      }, {root:true})
                    });
                  }
                }).catch(error => {
                  console.log(error)
                });
              }
            });
            commit('setPageArchive',1)
            dispatch('getArchiveData',rootState.authen.user)
            
            commit('setPage',1)
            dispatch('getMember',rootState.authen.user)
          }
        },
        deleteArchiveMember({commit,rootState,dispatch}:any,id:any){
          if(id != undefined){
            commit('setLoadingArchiveTable',true)
            commit('setMemberArchive', [])
            firebase.database().ref('users_employee_exit').child(id).remove()
            firebase.database().ref(`/users_company/${rootState.authen.user.company}/${id}`).remove()
            /*save logs*/
            dispatch('authen/addLogs', {
              company: rootState.authen.user.company,
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              id: id,
              table: 'users_employee_exit',
              status: 'remove',
              type: 'user_invalid',
              user: rootState.authen.user.email
            }, {root:true}).then(function() {
              commit('setPageArchive',1)
              dispatch('getArchiveData',rootState.authen.user)
            });
          }
        },
        deleteArchiveArrMember({commit,rootState,dispatch}:any,obj:any){
          if(obj.length > 0){
            _.forEach(obj, (item,key)=> {
              let id = item.key
              if(id != undefined){
                firebase.database().ref('users_employee_exit').child(id).remove()
                firebase.database().ref(`/users_company/${rootState.authen.user.company}/${id}`).remove()
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: rootState.authen.user.company,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: id,
                  table: 'users_employee_exit',
                  status: 'remove',
                  type: 'user_invalid',
                  user: rootState.authen.user.email
                }, {root:true})
              }
            });
            commit('setPageArchive',1)
            dispatch('getArchiveData',rootState.authen.user)
          }
        },
        async deleteAllArchiveMember({commit,rootState,dispatch}:any){
          await firebase.database().ref().child('users_employee_exit').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value',async snapshot => {
            snapshot.forEach((arrData):any => {
              const id = arrData.key
              if(id != undefined){
                firebase.database().ref('users_employee_exit').child(id).remove()
                firebase.database().ref(`/users_company/${rootState.authen.user.company}/${id}`).remove()
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: rootState.authen.user.company,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: id,
                  table: 'users_employee_exit',
                  status: 'remove',
                  type: 'user_invalid',
                  user: rootState.authen.user.email
                }, {root:true})
              }
            });
            commit('setPageArchive',1)
            dispatch('getArchiveData',rootState.authen.user)
          }).catch(error => {
            console.log(error)
          });
        },
        sortMember({commit,state}:any,value:any){
          var member: Array<any> = [];
          if(state.type == 'active'){
            member.push(state.datamembers['membersact'])
          }else if(state.type == 'inactive'){
            member.push(state.datamembers['membersinact'])
          }else if(state.type == 'new'){
            member.push(state.datamembers['membersnew'])
          }else if(state.type == 'invited'){
            member.push(state.datamembers['membersinvited'])
          }else{
            member.push(state.datamembers['membersall'])
          }
          if (state.inputSearch.length > 2){
            if (member.length > 0){
              var re = new RegExp(state.inputSearch, 'gi')
              var response = _.filter(member[0], (item): any => {
                if (item.firstname.match(re)) {
                  return true
                } else if (item.lastname != undefined && item.lastname.match(re)) {
                  return true
                } else if (item.value != undefined && (item.value.match(re))) {
                  return true
                } else if (item.email != undefined && item.email.match(re)) {
                  return true
                } else if (item.team_name != undefined && item.team_name.match(re)) {
                  return true
                }
              });
              member = []
              member.push(response)
            }
          }

          var size = state.size_page
          var page = state.page
          var field  = value[0]
          var order = value[1]
          var start_row = (page-1) * size
          var end_row = ((page-1) * size)+size
          if(field == 'name')
            field = 'value'

          if(order == 'ascending' || order == 'asc')
            order = 'asc'
          else
            order = 'desc'
          
          let checkOrder:Array<any> = [];
          let _users:Array<any> = [];
          if(state.incomplete.length > 0){
            checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
            if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
              _users = _.orderBy(member[0], ["inorder",field], ["asc",order]);
            }else{
              _users = _.orderBy(member[0], [field], [order]);
            }
          }else{
            _users = _.orderBy(member[0], [field], [order]);
          }
          // var _users = _.orderBy(member[0], ["inorder",field], ["asc",order]);
          commit('setSortfield', field)
          commit('setSortorder', order)
          commit('setMember', _users.slice(start_row,end_row))
        },
        sortMemberArchive({commit,state}:any,value:any){
          var member: Array<any> = [];
          member.push(state.membersArchiveAll)
          if (state.inputSearchArchive.length > 2){
            if (member.length > 0){
              var re = new RegExp(state.inputSearchArchive, 'gi')
              var response = _.filter(member[0], (item): any => {
                if (item.firstname.match(re)) {
                  return true
                } else if (item.lastname != undefined && item.lastname.match(re)) {
                  return true
                } else if (item.value != undefined && (item.value.match(re))) {
                  return true
                } else if (item.email != undefined && item.email.match(re)) {
                  return true
                } else if (item.team_name != undefined && item.team_name.match(re)) {
                  return true
                }
              });
              member = []
              member.push(response)
            }
          }

          var size = state.size_page
          var page = state.pagearchive
          var field  = value[0]
          var order = value[1]
          var start_row = (page-1) * size
          var end_row = ((page-1) * size)+size

          if(field == 'name')
            field = 'value'

          if(order == 'ascending' || order == 'asc'){
            if(field == 'exitdated'){
              order = 'desc'
            }else {
              order = 'asc'
            }
          }else {
            if(field == 'exitdated'){
              order = 'asc'
            }else{
              order = 'desc'
            }
          }
          var _users = _.orderBy(member[0], [field], [order]);
          commit('setSortfieldArchive', field)
          commit('setSortorderArchive', order)
          commit('setMemberArchive', _users.slice(start_row,end_row))
        },
        async getRelationshipMobile({commit,dispatch,state}:any, item:any){
          let testKey = firebase.database().ref('test').push().key;
          firebase.database().ref(`test/${testKey}`).update({
            code:item.code,
          })
          
          let bytes  = CryptoJS.AES.decrypt(item.code, 'HappilyRelationShip');
          let originalText = bytes.toString(CryptoJS.enc.Utf8);
          let codeSplit = originalText.split("===")
          let arrData:Array<any> = [];
          let relationships:any = {}
          let keyId = codeSplit[1].replace(/\./g, "||")
          
          const userData = (await firebase.database().ref(`/users/${keyId}`).once('value')).val()
          const rel_maps = (await firebase.database().ref(`/rel_maps/${keyId}`).once('value')).val()
          const houseData:Array<any> = [];
          houseData['-LWOr-XsbZM2digYl1QL'] = new Array()
          houseData['-LWOr-XsbZM2digYl1QL']['color'] = '#1d97f2'
          houseData['-LWPrOElCYViBd6j6qP-'] = new Array()
          houseData['-LWPrOElCYViBd6j6qP-']['color'] = '#ffbf1f'
          houseData['-LWPrZbcyHAVHIFUsWLd'] = new Array()
          houseData['-LWPrZbcyHAVHIFUsWLd']['color'] = '#ea183c'
          relationships.center = codeSplit[1]
          relationships.firstname = userData.firstname
          relationships.lastname = userData.lastname
          if(userData.profilepic_small){
            relationships.pic = userData.profilepic_small;
          }else if (userData.profilepic_crop){
            relationships.pic = userData.profilepic_crop;
          }else if (userData.profilepic){
            relationships.pic = userData.profilepic;
          }else {
            relationships.pic = "";
          }
          relationships.house_color = (houseData[userData.house] && houseData[userData.house].color) ? houseData[userData.house].color : ''
          relationships.dist_map = new Array()
          relationships.node_relations = new Array() 
          if(rel_maps && rel_maps.dists.length > 0){
            _.forEach(rel_maps.dists, (value,key)=> {
              let _item:any = value
              _item.distance = value.dist_norm
              _item.name = (value.team_name) ? value.team_name : ''
              _item.house_color = (value.house_id) ? houseData[value.house_id].color : ''
              _item.pic = value.pic;
              _item.firstname = value.firstname
              _item.lastname = value.lastname
              relationships.dist_map.push(_item)
            });
            _.forEach(rel_maps.edges, (value,key)=> {
              let _item:any = value
              relationships.node_relations.push(_item)
            });
          }
          arrData['relationships'] = relationships
          commit('setWebViewData', arrData)
        },
        async getModalMemberData({commit,dispatch,state}:any, item:any){
          let arrData:Array<any> = [];
          let peerfeedback = {}
          state.modalMemberData = []
          const typeMaster = (await firebase.database().ref('achievement_type').orderByChild("order_by").once('value')).val()
          await firebase.firestore().collection('users_achievements/').doc(item.email).get().then( async(doc)=> {
            if (doc.exists) {
              const _data:any = doc.data()
                if(_data.peerfeedback) peerfeedback = _data.peerfeedback
                const arrAch:Array<any> = [];
                const achievement_type:Array<any> = [];
                arrData['achievements_total'] = 0
                await firebase.firestore().collection('users_achievements/').doc(item.email).collection('achievements').get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (docAch) {
                      const _dataAch = docAch.data()
                      if(_dataAch.count1 == _dataAch.count1_total){
                        if (arrAch[_dataAch.type] === undefined) {
                          arrAch[_dataAch.type] = new Array();
                          arrAch[_dataAch.type].count = 0
                        }
                        if(_dataAch.count2){
                          if(_dataAch.count2 == _dataAch.count2_total){
                            arrAch[_dataAch.type].count += 1
                            arrData['achievements_total'] += 1
                          }
                        }else{
                          arrAch[_dataAch.type].count += 1
                          arrData['achievements_total'] += 1
                        }
                      }
                    });
                    if(peerfeedback){
                      let sort_peerfeedback = Object.keys(peerfeedback).sort(function(a,b){return peerfeedback[b] - peerfeedback[a]})
                      arrData['peerfeedback'] = new Object()
                      _.forEach(sort_peerfeedback, (value,key)=> {
                        arrData['peerfeedback'][value] = peerfeedback[value]
                      });
                    }
                    if(arrAch){
                      _.forEach(typeMaster, (value,key)=> {
                        let _data = value
                        if(_data.name && arrAch[_data.name]){
                          _data.count = arrAch[value.name]['count']
                        }else{
                          _data.count = 0
                        }
                        achievement_type.push(_data)
                      });
                      const achievement_type_order = _.orderBy(achievement_type, ['count'],['desc']);
                      arrData['achievements'] = achievement_type_order
                    }
                });
            }
          });
          let relationships:any = {}
          const rel_maps = await firebase.firestore().collection('rel_map_hist_quarterly').doc(`${item.email}-2025-Q3`).get().then((doc)=> {
            if(doc.exists){
              return doc.data()
            }
          })//(await firebase.database().ref(`/rel_maps/${item.key}`).once('value')).val()
          const houseData:Array<any> = [];
          houseData['-LWOr-XsbZM2digYl1QL'] = new Array()
          houseData['-LWOr-XsbZM2digYl1QL']['color'] = '#1d97f2'
          houseData['-LWPrOElCYViBd6j6qP-'] = new Array()
          houseData['-LWPrOElCYViBd6j6qP-']['color'] = '#ffbf1f'
          houseData['-LWPrZbcyHAVHIFUsWLd'] = new Array()
          houseData['-LWPrZbcyHAVHIFUsWLd']['color'] = '#ea183c'
          relationships.center = item.email
          relationships.firstname = item.firstname
          relationships.lastname = item.lastname
          relationships.pic = item.pic
          relationships.house_color = (houseData[item.house] && houseData[item.house].color) ? houseData[item.house].color : ''
          relationships.dist_map = new Array()
          relationships.node_relations = new Array() 
          if(rel_maps && rel_maps.dists.length > 0){
            _.forEach(rel_maps.dists, (value,key)=> {
              let _item:any = value
              _item.distance = value.dist_norm
              _item.name = (value.team_name) ? value.team_name : ''
              _item.house_color = (value.house_id) ? houseData[value.house_id].color : ''
              _item.pic = value.pic;
              _item.firstname = value.firstname
              _item.lastname = value.lastname
              relationships.dist_map.push(_item)
            });
            _.forEach(rel_maps.edges, (value,key)=> {
              let _item:any = value
              relationships.node_relations.push(_item)
            });
          }
          arrData['relationships'] = relationships
          
          let arrBoss:Array<any> = [];
          let tempItem:any
          let sub =  _.filter(state.datamembers['membersall'], { 'boss': item.email })
          let _userData = state.membersByKey[item.key]
          if(_userData){
            _userData.direct_report = (sub.length > 0) ? sub.length : 0
            arrBoss.push(_userData)
          }
          
          if(item.boss && (state.membersByKey[item.boss.replace(/\./g, "||")] != undefined)){
            tempItem = item
          do{
            let keyIdBoss = tempItem.boss.replace(/\./g, "||")
            let subOfBoss =  _.filter(state.datamembers['membersall'], { 'boss': tempItem.boss })
            let u = state.membersByKey[keyIdBoss]
            if(u){
              u.direct_report = (subOfBoss.length > 0) ? subOfBoss.length : 0
              arrBoss.push(u)
            }
            if(u.boss){
              tempItem = u
            }else{
              tempItem = []
            }
          }
          while(tempItem.boss)
          }
          arrData['org'] = arrBoss.reverse()
          console.log("arrData",arrData);
          commit('setModalMemberData', arrData)
        },
        async assignManagerSubmit({commit,rootState,dispatch,state}:any, objData:any){
          commit('setLoadingMemberTable',true)
          commit('setMember',[])
          let member = objData.memberData
          let manager = objData.manager
          const userComp = rootState.authen.user.company
          if(member && manager){
            _.forEach(member, (item,key)=> {
              firebase.database().ref(`/users/${item.key}`).update({
                boss:manager,
                modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
              }).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: userComp,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: item.key,
                  table: 'users',
                  status: 'assignManager',
                  user: rootState.authen.user.email
                }, {root:true})
              });
            });
            firebase.database().ref(`/genboss`).push({
              company:userComp
            }).then(function() {
              commit('setPage',1)
              dispatch('getMember',rootState.authen.user)
            });
          }
        },
        async ReAssignManagerSubmit({commit,rootState,dispatch,state}:any, objData:any){
          commit('setLoadingMemberTable',true)
          commit('setMember',[])
          let member = objData.memberData
          let manager = objData.manager
          const userComp = rootState.authen.user.company
          if(member && manager){
            _.forEach(member, (item,key)=> {
              let data = {}
              if(item.email == manager){
                data['boss'] = ""
              }else{
                data['boss'] = manager
              }
              data['modifydatetime'] = format(new Date(), 'YYYY-MM-DD HH:mm')
              
              firebase.database().ref(`/users/${item.key}`).update(data).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: userComp,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: item.key,
                  table: 'users',
                  status: 'ReAssignManager',
                  user: rootState.authen.user.email
                }, {root:true})
              });
            });
            firebase.database().ref(`/genboss`).push({
              company:userComp
            }).then(function() {
              commit('setPage',1)
              dispatch('getMember',rootState.authen.user)
            });
          }
        },
        async assignTeamSubmit({commit,rootState,dispatch,state}:any, objData:any){
          commit('setLoadingMemberTable',true)
          commit('setMember',[])
          let member = objData.memberData
          let team = objData.team
          const userComp = rootState.authen.user.company
          if(member && team){
            _.forEach(member, (item,key)=> {
              firebase.database().ref(`/users/${item.key}`).update({
                team:team,
                modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
              }).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: userComp,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: item.key,
                  table: 'users',
                  status: 'assignTeam',
                  user: rootState.authen.user.email
                }, {root:true})
              });
            });
            firebase.database().ref(`/genboss`).push({
              company:userComp
            }).then(function() {
              commit('setPage',1)
              dispatch('getMember',rootState.authen.user)
            });
          }
        },
        async getArchiveData({commit,rootState,dispatch,state}:any, user:any){
          commit('setLoadingArchiveTable',true)
          const users:Array<any> = [];
          const memberKey:Array<any> = [];
          state.membersArchive = []
          state.membersArchiveAll = []
          const team = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
          await firebase.database().ref().child('users_employee_exit').orderByChild('company').equalTo(`${user.company}`).once('value',async snapshot => {
            snapshot.forEach((arrData):any => {
              const u = arrData.val()
              u.key = arrData.key
              u.value = arrData.val().firstname + " " + arrData.val().lastname
              if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
              if(u.profilepic_small){
                u.pic = u.profilepic_small;
              }else if (u.profilepic_crop){
                u.pic = u.profilepic_crop;
              }else if (u.profilepic){
                u.pic = u.profilepic;
              }else {
                u.pic = "";
              }
              if(u.exitdated){
                u.archiveddate = globalfunc.timeSince(u.exitdated)
              }
              memberKey[u.key] = u
              users.push(u)
            });
            var _users = _.sortBy(users, [function(o:any) { return o.firstname; }])
            commit('setMemberArchiveKey', memberKey)
            commit('setResultsArchive',users)
            commit('setMemberArchive', _.sortBy(_users.slice(0, state.size_page), [function(o:any) { return o.firstname; }]))
            commit('setMemberArchiveAll', _.sortBy(users, [function(o:any) { return o.firstname; }]))
            commit('setLoadingArchiveTable',false)
            if(state.inputSearchArchive){
              dispatch('searchMembersArchive',state.inputSearchArchive)
            }
          }).catch(error => {
            console.log(error)
          });
        },
      },
      getters: {
        datamembers : (state:any) => {
          return state.datamembers
        },
        members : (state:any) => {
            return state.members
        },
        team : (state:any) => {
          return state.teamall
        },
        inputSearch: (state:any) => {
          return state.inputSearch
        },
        inputSearchArchive: (state:any) => {
          return state.inputSearchArchive
        },
        sizepage: (state:any) => {
          return state.size_page
        },
        dataexport : (state:any) => {
          return state.dataexport
        },
        results : (state:any) => {
          return state.results
        },
        resultsArchive : (state:any) => {
          return state.resultsArchive
        },
        page : (state:any) => {
          return state.page
        },
        pagearchive : (state:any) => {
          return state.pagearchive
        },
        modalMemberData : (state:any) => {
          return state.modalMemberData
        },
        membersByKey : (state:any) => {
          return state.membersByKey
        },
        membersArchiveByKey : (state:any) => {
          return state.membersArchiveByKey
        },
        bossByKey : (state:any) => {
          return state.bossByKey
        },
        teamByKey : (state:any) => {
          return state.teamByKey
        },
        teamParentByKey : (state:any) => {
          return state.teamParentByKey
        },
        membersArchive : (state:any) => {
          return state.membersArchive
        },
        membersArchiveAll : (state:any) => {
          return state.membersArchiveAll
        },
        incomplete : (state:any) => {
          return state.incomplete
        },
        loadingMemberTable : (state:any) => {
          return state.loadingMemberTable
        },
        loadingArchiveTable : (state:any) => {
          return state.loadingArchiveTable
        },
        loadingOrgChartView : (state:any) => {
          return state.loadingOrgChartView
        },
        webviewData : (state:any) => {
          return state.webviewData
        },
        allArchiveData : (state:any) => {
          return state.allArchiveData
        },
        managerMembers : (state:any) => {
          return state.managerMembers
        },
        orgChartView : (state:any) => {
          return state.orgChartView
        },
      }
  }